import { MapfreIconComponent } from '../../individual-components/mapfre-icon/mapfre-icon.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreIconComponent],
  selector: 'mapfre-icon-information',
  templateUrl: './mapfre-icon-information.component.html'
})
export class MapfreIconInformationComponent{
	@Input() data = '';
	@Input() iconClasses = '';
  @Input() iconFamily = 'material-icons';
  @Input() titleType = '';


}
